import httpRequest from "services/httpRequest";

const prefix = "/api/upload";

export const onUpload = async params => {
  const formData = new FormData();
  formData.append("file", params.file);
  const result = await httpRequest({
    url: `${prefix}`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      cannedAccessControlList: params.cannedAccessControlList,
      uploadFileType: params.uploadFileType,
    },
    data: formData,
    successMessage: "toast.upload_success",
  });
  return result;
};
